import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { View } from "@/views/translation/View";
import { loadTranslation, storeTranslation } from '@/reducers/Translation'
import { show } from '@/reducers/Modal'
import i18n from "i18next";
import { useTranslation, withTranslation, Trans } from "react-i18next";
import {resetApplicationKey} from '@/reducers/ApplicationReducer';

class TranslationController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null, prevType: props.type, init: true };
    
    this.onSaveHandler = this.onSaveHandler.bind(this);
  }

    async componentDidMount() {
        const {TranslationReducer} = this.props;
        
        
        //if(isLoggedIn && user.id == 0) {
                store.dispatch(loadTranslation({})); 
        try {
            
//                const dispatch = useDispatch();
            
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }            
    }
componentDidUpdate() {
    const {prevType} = this.state;
    const {type} = this.props;
    const { dispatch } = this.props;
    //store.dispatch(loadTranslation());

}
shouldComponentUpdate12() {
    const {prevType} = this.state;
    const {type} = this.props;
    const { dispatch } = this.props;
    if(type != prevType) {
        //this.setState({prevType : type});
        //dispatch(loadUsers(type)); 
        return true;
    }
    return false;    
}

onSaveHandler(data) {
  
    store.dispatch( storeTranslation(data) ).then((result) => {
                    let p = i18n.reloadResources();
                    
                    p.then( (data) => {
                        store.dispatch( resetApplicationKey({key: result.payload.data.translations.uuid }));
                    });
                });
}

  render() {
    const {prevType} = this.state;
    const {TranslationReducer} = this.props;

    return (
      <View key={TranslationReducer?.key} {...this.props} onSaveHandler={this.onSaveHandler}/>
    );
  }
}

const TeamControllerInit = (props) => {
  const { t, i18n, ready } = useTranslation();

  return (
    <TeamController
      {...props}
      t={t}
    />
  );
};

function mapStateToProps(state) {
    const {TranslationReducer} = state;
    const {translations, key} = TranslationReducer;
  return {
      TranslationReducer,
      translations,
      updateKey: key
  };
}
export default connect(mapStateToProps)(TranslationController);
